import jQuery from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import LazyEmbed from 'lazyembed2';
import objectFitVideos from 'object-fit-videos';
import Isotope from 'isotope-layout';
import PageLoadedQueue from "./PageLoadedQueue";
import Viewport from "./Viewport";
import SizeChanged from "./SizeChanged";

window.jQuery = window.$ = jQuery;
window.LazyLoad = LazyLoad;
window.LazyEmbed = LazyEmbed;
window.objectFitVideos = objectFitVideos;
window.Isotope = Isotope;
window.rubyMenu = undefined;
window.PageLoadedQueue = PageLoadedQueue;
window.Viewport = new Viewport();
window.SizeChanged = SizeChanged;
